import { HTMLProps, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { PensionContext } from '../../../../contexts/pension-robot/PensionContext';
import { isPensionCalculatedTogether } from '../../../../utils/functions';
import { PlusAndMinusPensionAgeButton } from './PlusAndMinusPensionAgeButton';

export const ChangePensionAge: React.FC<HTMLProps<HTMLDivElement>> = () => {
    const { t } = useTranslation('pension');
    const { parameters: { personalInfo } } = useContext(PensionContext);
    const isCalculatedTogether = isPensionCalculatedTogether(personalInfo);

    return (
        <div className="p-4 pb-8 border-b">
            <span>
                {t('pension-result-disclosure-change-pension-age-text-goal-achieved')}
            </span>
            <div className="flex flex-row flex-wrap gap-4 mt-2">
                <PlusAndMinusPensionAgeButton className="mr-6" />
                {isCalculatedTogether && <PlusAndMinusPensionAgeButton isPartnerPension={true} />}
            </div>
        </div>
    );
};
